import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LineSPF from '../../../../../../Viewer/LineSPF/LineSPF';
import { mockActionStruct, mockFilters } from '../mock';
import PreviewActions from './PreviewActions';
import { useActionsColors } from '../../../../../../hooks/useCurrentTheme';
import PreviewDataLegend from './PreviewDataLegend';
import { convertationActionMultiStack } from '../../../../../../helpers/helpers';
var PreviewEquityLineAndActions = function (_a) {
    var title = _a.title;
    var getColor = useActionsColors();
    var dataLegendSections = mockActionStruct.map(function (item, index) { return ({
        id: item.id,
        name: convertationActionMultiStack(item.action, item.raiseIndex, item.isAllIn),
        isAllIn: item.isAllIn,
        raiseIndex: item.raiseIndex,
        color: getColor(item.action, item.raiseIndex, item.isAllIn),
        percent: 33,
        combos: (index + 1) * 14,
    }); });
    return (_jsxs("div", { children: [_jsx(LineSPF, { isSettings: true, mockActionStruct: mockActionStruct, mockStrategyFilters: mockFilters }), _jsx(PreviewDataLegend, { actions: dataLegendSections }), title === 'actions' ? _jsx(PreviewActions, {}) : null] }));
};
export default PreviewEquityLineAndActions;
